import { ChangeDetectionStrategy, Component, ContentChild, ContentChildren, Input, QueryList, TemplateRef } from "@angular/core";
import { NzCardComponent } from "ng-zorro-antd/card";
import { WithConfig } from "ng-zorro-antd/core/config";
import { NgStyleInterface } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiCardTabComponent } from "@webapp/ui/card/components/card-tab/card-tab.component";
import { UiCardGridDirective } from "@webapp/ui/card/directives/card-grid.directive";
import { UiSizeDSType } from "@webapp/ui/core/models/ui-size.models";

@Component({
  selector: "ui-card",
  exportAs: "uiCard",
  templateUrl: "card.component.html",
  styleUrls: ["./card.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCardComponent extends NzCardComponent {
  @Input("uiBordered") @WithConfig() @InputBoolean() public nzBordered = true;
  @Input("uiBorderless") @WithConfig() @InputBoolean() public nzBorderless = false;
  @Input("uiLoading") @InputBoolean() public nzLoading = false;
  @Input("uiHoverable") @WithConfig() @InputBoolean() public nzHoverable = false;
  @Input("uiBodyStyle") public nzBodyStyle: NgStyleInterface | null = null;
  @Input("uiCover") public nzCover?: TemplateRef<void>;
  @Input("uiActions") public nzActions: Array<TemplateRef<void>> = [];
  @Input("uiType") public nzType: string | "inner" | null = null;
  @Input("uiSize") @WithConfig() public nzSize: UiSizeDSType = "default";
  @Input("uiTitle") public nzTitle?: string | TemplateRef<void>;
  @Input("uiExtra") public nzExtra?: string | TemplateRef<void>;
  @ContentChild(UiCardTabComponent, { static: false }) public listOfNzCardTabComponent?: UiCardTabComponent;
  @ContentChildren(UiCardGridDirective) public listOfNzCardGridDirective!: QueryList<UiCardGridDirective>;
}
